import api from "./api";

const services = { api };

export default services;
